import { propOr } from 'ramda'
import emptyComplianceState from 'features/compliance/ducks/state'
import {
  flagObligationRoutine,
  createObligationRoutine,
  fetchTaskDomainsRoutine,
} from 'features/compliance/ducks/actions'

export default (state = emptyComplianceState, action) => {
  switch (action.type) {
    case fetchTaskDomainsRoutine.REQUEST:
      return { ...state, taskDomainsLoading: true }
    case fetchTaskDomainsRoutine.SUCCESS:
      return {
        ...state,
        taskDomains: propOr([], 'payload', action),
        taskDomainsLoading: false,
      }
    case fetchTaskDomainsRoutine.FAILURE:
      return { ...state, taskDomainsLoading: false }

    case flagObligationRoutine.REQUEST:
      return { ...state, flagSubmitting: true }
    case flagObligationRoutine.SUCCESS:
    case flagObligationRoutine.FAILURE:
      return { ...state, flagSubmitting: false }

    case createObligationRoutine.REQUEST:
      return { ...state, createSubmitting: true }
    case createObligationRoutine.SUCCESS:
      return {
        ...state,
        createSubmitting: false,
        createdObligations: [propOr(null, 'payload', action), ...state.createdObligations].filter(Boolean),
      }
    case createObligationRoutine.FAILURE:
      return { ...state, createSubmitting: false }

    default:
      return state
  }
}
